import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-phone-fill",
  "use": "icon-phone-fill-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-phone-fill\">\n  <path d=\"M170.666667 0v967.111111h682.666666V0z m341.333333 910.222222a85.333333 85.333333 0 1 1 85.333333-85.333333A85.333333 85.333333 0 0 1 512 910.222222z m227.555556-227.555555H284.444444V113.777778h455.111112z\" fill=\"currentColor\" p-id=\"1292\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol